<template>
  <div v-title="$route.name">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.params.type==='10'">客户管理</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.params.type==='1'">财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <template slot="header">
        <el-col :span="5">已回款金额总计：
          <span v-for="item in options.currency_type"
                v-if="$route.query.currency_type  * 1 === item.value"
          >{{item.symbol}}</span> {{received_amount_total | seperateThousandsToFixed(2)}}</el-col>
        <el-col :span="5">未回款金额总计：
          <span v-for="item in options.currency_type"
                v-if="$route.query.currency_type  * 1 === item.value"
        >{{item.symbol}}</span> {{unreceived_amount_total | seperateThousandsToFixed(2)}}</el-col>
      </template>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="序号"
                         min-width="90">
          <template slot-scope="scope">
           {{scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="type"
                         label="开票类型"
                         min-width="120">
        </el-table-column>
        <el-table-column label="项目名称/编号"
                         width="190">
          <!--客户名/编号-->
          <template slot-scope="scope">
            <template v-if="scope.row.issued_type * 1 === 1">
              {{scope.row.project_name}}/{{scope.row.project_number}}
            </template>
            <template v-if="scope.row.issued_type * 1 === 2">
                {{scope.row.virtual_project.name}}/{{scope.row.virtual_project.number}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="do_number"
                         label="DO/PO单号"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="budget"
                         label="项目预算"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="$route.query.currency_type  * 1 === item.value"
            >{{item.symbol}}</span>
            {{scope.row.budget | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="cost"
                         label="项目成本"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="$route.query.currency_type  * 1 === item.value"
            >{{item.symbol}}</span>
            {{scope.row.cost | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="invoice_time"
                         label="开票日期"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="invoice_number"
                         label="发票号码"
                         min-width="120">
        </el-table-column>
        <el-table-column
          prop="cost_type"
          label="开票名称">
          <template slot-scope="scope">
            <span>{{ scope.row.invoice_full_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_type"
          label="开票金额依据">
          <template slot-scope="scope">
              <span v-for="item in options.tax_type"
                    v-if="scope.row.tax_type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="untaxed_amount"
          label="未税金额">
          <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="$route.query.currency_type  * 1 === item.value"
            >{{item.symbol}}</span>
           {{scope.row.untaxed_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_rate"
          label="税率">
          <template slot-scope="scope">
            {{scope.row.tax_rate}}%
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          label="含税开票金额">
          <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="$route.query.currency_type  * 1 === item.value"
            >{{item.symbol}}</span>
            {{scope.row.total | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="received_amount"
                         label="已回款金额"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="$route.query.currency_type  * 1 === item.value"
            >{{item.symbol}}</span>
            {{scope.row.received_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column label="未回款金额"
                         prop="unreceived_amount"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.currency_type"
                  v-if="$route.query.currency_type  * 1 === item.value"
            >{{item.symbol}}</span>
            {{scope.row.unreceived_amount | seperateThousandsToFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="received_payment_status"
                         label="回款状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.received_payment_status"
                  v-if="scope.row.received_payment_status === item.value"
            >{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="received_payment_time"
                         label="回款日期"
                         min-width="120">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="230">
          <template slot-scope="scope">
            <el-button type="primary"
                       size="mini"
                       v-if="scope.row.received_payment_status !== 2 && $route.params.type==='1'"
                       @click="addPaymentLog(scope.row)">回款
            </el-button>
            <router-link
              :to="{path: '/invoice-apply/received-payment-log/' + scope.row.id}">
              <el-button size="mini">日志
              </el-button>
            </router-link>
            <el-button type="primary"
                       size="mini"
                       v-if="scope.row.received_payment_status !== 2 && $route.params.type==='1'"
                       @click="completePayment(scope.row.id)">完成回款
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </layout-panel>
    <received-payment-dialog ref="receiptPaymentDialog" @refresh="onRefresh"></received-payment-dialog>
  </div>
</template>

<script>
import { searchRules } from '../invoice-apply.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'
import selectRemote from '@core/mixins/selectRemote'
import ReceivedPaymentDialog from '@/views/invoice-apply/components/ReceivedPaymentDialog'

export default {
  mixins: [table, dateTimePicker, selectRemote],
  components: {
    ReceivedPaymentDialog
  },
  data () {
    return {
      searchRules,
      search: {
      },
      selectLoading: false,
      customerItems: [],
      projectItems: [],
      adminuserItems: [],
      visible: false,
      dialogType: null,
      currentId: null,
      title: null,
      received_amount_total: 0,
      unreceived_amount_total: 0,
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
    }),
  },
  async created () {},
  methods: {
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      params.id = this.$route.params.id
      return request.page('getReceivedPaymentDetail', params)
    },
    setTableData ({data}) {
      this.$set(this, 'table', data.data)
      this.setPagination(data)
      this.computeAmount(data)
    },
    computeAmount (data) {
      let receivedAmountTotal = 0
      let unreceivedAmountTotal = 0
      for (const i in data.data) {
        if (data.data.hasOwnProperty(i)) {
          receivedAmountTotal = receivedAmountTotal + Number(data.data[i].received_amount)
          unreceivedAmountTotal = unreceivedAmountTotal + Number(data.data[i].unreceived_amount)
        }
      }
      this.received_amount_total = receivedAmountTotal
      this.unreceived_amount_total = unreceivedAmountTotal
    },
    completePayment (id) {
      this.$confirm('此操作将完成回款, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('completeReceivedPayment', {id: id}).then((res) => {
          this.$message.success('完成回款成功')
          this.onRefresh()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    addPaymentLog (row) {
      let params = {id: row.id, unreceived_amount: row.unreceived_amount, total: row.total}
      this.$refs.receiptPaymentDialog.openDialog(params)
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/ReceivedPaymentDetailTable.vue